import styled from 'react-emotion';
import {
  Table, Select, DatePicker, Input, Radio, Button, InputNumber, Divider,
} from 'antd';
import LoadSpinnerOverlay from '../LoadSpinner';

/* This wrapper is made for IE11 oddities */
export const Wrapper = styled('div')`
  height: 100%;
  width: 100%;

  .ant-radio-button-wrapper {
    padding: 0 8px;
  }

  .ant-select-selection__choice {
    padding: 0 18px 0 6px;
  }

  .ant-input-group {
    width: auto;
  }

  .ant-divider {
    height: 100%;
  }
`;

export const TableWrapper = styled('div')`
  height: calc(100vh - 170px);
  overflow-y: scroll;

  .ant-table-wrapper {
    margin-top: -25px;
  }
`;

export const Loading = styled(LoadSpinnerOverlay)` &&& {
  bottom: 0;
  width: 100%;
  height: inherit;
  background-color: white;
}`;

export const AreaTable = styled(Table)`
  text-transform: capitalize;

  th, td {
    font-size: 13px;
    padding-left: 12px !important;
  }
`;

export const DataTable = styled(Table)`
  .ant-table-row-selected td {
    background: initial !important;
  }
`;

export const SourceSelect = styled(Select)`
  text-transform: capitalize;
  display: inline-block;
  min-width: 100px;
`;

export const DayViewSelect = styled(Select)`
  > div {
    min-width: 120px;
  }
`;

export const { Option } = Select;

export const RangePicker = styled(DatePicker.RangePicker)`
  width: 220px;
`;

export const Picker = styled(Input.Group)`
  .ant-select-enabled {
    /* Needed for IE11 */
    height: 32px;
  }
`;

export const OptionGroup = styled(Radio.Group)`
  text-transform: capitalize;  
`;

export const Volume = styled('a')`
  ${({ disabled }) => disabled && 'color: inherit !important'};
`;

export const ModifyOption = styled(Radio)`
  width: 80px;
  height: 2rem;
  line-height: 2rem;
`;

export const ModifyAmount = styled(InputNumber)`
  width: 80px;
`;

export const OKButton = styled(Button)`
  display: block;
  width: 100%;
  margin-top: 10px;
`;

export const DaySelect = styled(Select)`
  text-transform: capitalize;
  min-width: 110px;
  .ant-select-selection {
    /* IE11 >:( */
    height: 1rem;
  }
`;

export const VolumeDivider = styled(Divider)`
  margin: 0 1rem;
`;

export const ExpandButton = styled(Button)`
  z-index: 1;
  top: 15px;
  left: 15px;
`;

export const ToolbarSection = styled('section')`
  strong {
    text-transform: uppercase;
    color: #aaa;
  }
  > div {
    display: flex;
  }
  .ant-radio-group:not(:only-of-type) {
    margin-right: 0.5em;
  }
`;
